import { useLang } from 'hooks/lang';
import { TFunction } from 'i18next';

import { LoggedUser } from 'entities';

import { useUser } from './user';

interface UseCommon {
  user: LoggedUser;
  t: TFunction;
}

export function useCommon(): UseCommon {
  const user = useUser();
  const { t } = useLang();

  return {
    user,
    t,
  };
}
